import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IContacto } from "../model";

export default class ContactoService extends ServiceBase {
  get = (data:{ user?: string, id?: number }) : Promise<IResponse<IContacto>> => 
    this.GetFetch<IResponse<IContacto>>('entity/contacto', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, idcliente?: number, tipo?: string, nombre?: string, apellido?: string, direccion?: string, tipoemail?: string, email?: string, tipoemail2?: string, email2?: string, tipotelefono?: string, telefono?: string, tipotelefono2?: string, telefono2?: string, activo?: boolean }) : Promise<IPaginatedResponse<IContacto>> => 
    this.GetFetch<IPaginatedResponse<IContacto>>('entity/contacto/find', data);

  all = () : Promise<IResponse<IContacto[]>> => 
    this.GetFetch<IResponse<IContacto[]>>('entity/contacto/all', {});

  upsert = (data:IContacto) : Promise<IResponse<IContacto>> => 
    this.PostFetch<IResponse<IContacto>>('entity/contacto', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/contacto', data);  
}
